/** VoiceOver reads the whole current word; this allows for the word to be read, then gives the aria-live region time to announce word count */
export const MAGIC_TEXT_DEBOUNCE_FOR_SR = 1340;
